import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(() =>
  createStyles({
    skeleton: {
      alignItems: 'flex-start',
    },
  })
);
